import { fullscreenExcludeVideoOverlayStates } from "@/lib/constants";
import styles from "@/styles/Video.module.scss";
import { useCallback } from "react";
import NextEpisode from "./NextEpisode";
import classnames from "classnames";
import { jsx as _jsx } from "react/jsx-runtime";
export default function FullScreenOverlay(_ref) {
  var state = _ref.state,
      error = _ref.error,
      watch = _ref.watch,
      player = _ref.player,
      fullScreen = _ref.fullScreen;
  var handleFirst = useCallback(function () {
    state.updateResumePoint(0);
  }, []);
  if (!state.overlay && !error) return null;

  if (fullScreen) {
    if (state.reason === "next_episode") {
      if (watch !== null && watch !== void 0 && watch.nextEpisode) {
        return /*#__PURE__*/_jsx("div", {
          className: classnames(styles.overlay, styles.fullScreen),
          children: /*#__PURE__*/_jsx(NextEpisode, {
            className: styles.fullScreen,
            watch: watch,
            state: state
          })
        });
      } else return null;
    } else if (state.reason === "resume") {
      // Windows Chromeでレジュームありの場合視聴開始しないので、視聴開始する
      handleFirst();
    } else if (!!state.reason && fullscreenExcludeVideoOverlayStates.includes(state.reason)) {
      player === null || player === void 0 ? void 0 : player.exitFullscreen();
    }
  }

  return null;
}